import { TYPES } from 'action-types/invoices';
import {
    emptyInvoiceDetails,
    emptyIssoDetails,
    IInvoiceDetails,
    IISSODetails,
    IIssueInvoices, ISearchInvoices
} from './models';
import * as msgs from '../../constants/validationMessages';

interface IAction {
    readonly type: string;
    readonly invoices: IIssueInvoices;
    readonly etsInvoices: IIssueInvoices;
    readonly searchInvoices:ISearchInvoices;
    readonly invoicesList: any[];
    readonly history: any[];
    readonly invoicedResponse: any[];
    readonly invoiceDetails: IInvoiceDetails;
    readonly issoDetails: IISSODetails;
    readonly errors: any[];
    readonly creditNoteResponse:any
    readonly reprintResponse:any,
    readonly downloadResponse:any
    readonly downloadPDFResponse:any
    readonly searchCustomerInvoices:any
    readonly isReprintOrDraftInvoiceAllowed:any
}
export interface IInvoicesState {
    readonly isFetchInvoicesDataLoading: boolean;
    readonly creditNoteError: boolean;
    readonly creditNoteLoading: boolean;
    readonly reprintLoading: boolean;
    readonly reprintError: boolean;
    readonly downloadError: boolean;
    readonly isFetchInvoicesDataError: boolean;
    readonly invoicesDetailsPendingError: string | string[];
    readonly isfetchInvoicesSearchLoading: boolean;
    readonly isfetchInvoicesSearchError: boolean;
    readonly fetchInvoicesSearchError: string | string[];
    readonly invoices: IIssueInvoices;
    readonly etsInvoices: IIssueInvoices;
    readonly invoicesList: any;
    readonly searchInvoices: ISearchInvoices;
    readonly searchInvoicesDestination: ISearchInvoices;
    readonly invoiceDetails: IInvoiceDetails;
    readonly issoDetails: IISSODetails;
    readonly submitInvoicedError: boolean;
    readonly invoicedResponse: any
    readonly history: any[];
    readonly historyError: string | string[];
    readonly isFetchHistoryLoading: boolean;
    readonly isFetchHistoryLoadingError: boolean;
    readonly creditNoteResponse: any
    readonly reprintResponse:any,
    readonly downloadResponse:any,
    readonly downloadPDFResponse:any,
    readonly searchCustomerInvoices:any;
    readonly loadingCustomerInvoices: boolean,
    readonly errorCustomerInvoices: boolean,
    readonly pendingError: string,
    readonly isReprintOrDraftInvoiceAllowed:any
    readonly isReprintOrDraftInvoiceAllowedError:boolean
}

export const defaultState: IInvoicesState = {
    isFetchInvoicesDataLoading: false,
    isFetchInvoicesDataError: false,
    creditNoteLoading: false,
    reprintLoading: false,
    creditNoteError: false,
    reprintError: false,
    downloadError: false,
    submitInvoicedError: false,
    isfetchInvoicesSearchLoading: false,
    isfetchInvoicesSearchError: false,
    isFetchHistoryLoading: false,
    isFetchHistoryLoadingError: false,
    fetchInvoicesSearchError: '',
    invoicesDetailsPendingError: '',
    invoices: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    etsInvoices: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    searchInvoices: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    searchInvoicesDestination: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    searchCustomerInvoices: {
        pageNumber: 1,
        pageSize: 0,
        result: [],
        totalCount: 0
    },
    invoiceDetails: emptyInvoiceDetails,
    issoDetails: emptyIssoDetails,
    invoicedResponse: '',
    creditNoteResponse: '',
    invoicesList: [],
    historyError: '',
    history: [],
    reprintResponse:'',
    downloadResponse:'',
    downloadPDFResponse:'',
    loadingCustomerInvoices: false,
    errorCustomerInvoices: false,
    pendingError: '',
    isReprintOrDraftInvoiceAllowed: '',
    isReprintOrDraftInvoiceAllowedError: false
};
const checkIfNull = (data:IIssueInvoices) => {
    if(!data.result){
        data.result = []
    }
    return data
}
const checkErr = (err:any)=>{
    if(err && !Array.isArray(err) ||
    (err && Array.isArray(err) && err.length > 0)){
        return err
    }
    return ''
}
export const reducer = (state: IInvoicesState = defaultState, action: IAction): IInvoicesState => {
    switch (action.type) {
        case TYPES.SET_SELECTED_INVOICES.FULFILLED:
            return {
                ...state,
                invoicesList: action.invoicesList,
            };
        case TYPES.RESET_INVOICES.PENDING:
            return {
                ...state,
                isFetchInvoicesDataLoading: true,
                isFetchInvoicesDataError: false,
                submitInvoicedError: false,
                invoicesDetailsPendingError: '',
                invoicedResponse: ''
            };
        case TYPES.RESET_INVOICES.FULFILLED:
            return {
                ...state,
                invoices: checkIfNull(action.invoices),
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_INVOICES_DATA.PENDING:
            return {
                ...state,
                isFetchInvoicesDataLoading: true,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_INVOICES_DATA.FULFILLED:
            return {
                ...state,
                invoices: checkIfNull(action.invoices),
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_INVOICES_DATA.REJECTED:
            return {
                ...state,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: true,
                invoicesDetailsPendingError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Pending_Error
            };
        case TYPES.FETCH_ETS_INVOICES_DATA.PENDING:
            return {
                ...state,
                isFetchInvoicesDataLoading: true,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_ETS_INVOICES_DATA.FULFILLED:
            return {
                ...state,
                etsInvoices: checkIfNull(action.etsInvoices),
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_ETS_INVOICES_DATA.REJECTED:
            return {
                ...state,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: true,
                invoicesDetailsPendingError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Pending_Error
            };
        case TYPES.RESET_ETS_INVOICES.FULFILLED:
            return {
                ...state,
                etsInvoices: defaultState.etsInvoices,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.SEARCH_INVOICES.PENDING:
            return {
                ...state,
                isfetchInvoicesSearchLoading: true,
                isfetchInvoicesSearchError: false,
                fetchInvoicesSearchError: ''
            };
        case TYPES.SEARCH_INVOICES.FULFILLED:
            return {
                ...state,
                searchInvoices: action.searchInvoices,
                isfetchInvoicesSearchLoading: false,
                isfetchInvoicesSearchError: false,
            };
        case TYPES.SEARCH_INVOICES.REJECTED:
            return {
                ...state,
                isfetchInvoicesSearchLoading: false,
                isfetchInvoicesSearchError: true,
                fetchInvoicesSearchError: action.errors?checkErr(action.errors): msgs.Invoices.Search_Error
            };
        case TYPES.SEARCH_INVOICES_DESTINATION.PENDING:
            return {
                ...state,
                isfetchInvoicesSearchLoading: true,
                isfetchInvoicesSearchError: false,
                fetchInvoicesSearchError: '',
                searchInvoicesDestination: defaultState.searchInvoices,
            };
        case TYPES.SEARCH_INVOICES_DESTINATION.FULFILLED:
            return {
                ...state,
                searchInvoicesDestination: action.searchInvoices,
                isfetchInvoicesSearchLoading: false,
                isfetchInvoicesSearchError: false,
            };
        case TYPES.SEARCH_INVOICES_DESTINATION.REJECTED:
            return {
                ...state,
                isfetchInvoicesSearchLoading: false,
                isfetchInvoicesSearchError: true,
                fetchInvoicesSearchError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Search_Error
            };
        case TYPES.SUBMIT_INVOICES.PENDING:
            return {
                ...state,
                isfetchInvoicesSearchLoading: true,
                submitInvoicedError: false,
                invoicedResponse: ''
            };
        case TYPES.SUBMIT_INVOICES.FULFILLED:
            return {
                ...state,
                isfetchInvoicesSearchLoading: false,
                submitInvoicedError: false,
                invoicedResponse: action.invoicedResponse
            };
        case TYPES.SUBMIT_INVOICES.REJECTED:
            return {
                ...state,
                isfetchInvoicesSearchLoading: false,
                submitInvoicedError: true,
                invoicedResponse: checkErr(action.errors)?checkErr(action.errors):'Submit Invoice has failed'
            };
        case TYPES.RESET_SUBMIT_INVOICES.FULFILLED:
            return {
                ...state,
                isfetchInvoicesSearchLoading: false,
                submitInvoicedError: false,
                invoicedResponse: ''
            };
        case TYPES.FETCH_INVOICE_DETAILS.PENDING:
            return {
                ...state,
                isFetchInvoicesDataLoading: true,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_INVOICE_DETAILS.FULFILLED:
            return {
                ...state,
                invoiceDetails: action.invoiceDetails? action.invoiceDetails: defaultState.invoiceDetails,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_INVOICE_DETAILS.REJECTED:
            return {
                ...state,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: true,
                invoicesDetailsPendingError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Retrieve_Error
            };
        case TYPES.FETCH_ISSO_DETAILS.PENDING:
            return {
                ...state,
                isFetchInvoicesDataLoading: true,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_ISSO_DETAILS.FULFILLED:
            return {
                ...state,
                issoDetails: action.issoDetails? action.issoDetails: defaultState.issoDetails,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: false,
                invoicesDetailsPendingError: ''
            };
        case TYPES.FETCH_ISSO_DETAILS.REJECTED:
            return {
                ...state,
                isFetchInvoicesDataLoading: false,
                isFetchInvoicesDataError: true,
                invoicesDetailsPendingError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Retrieve_Error
            };
        case TYPES.FETCH_INVOICE_HISTORY.PENDING:
            return {
                ...state,
                isFetchHistoryLoading: true,
                isFetchHistoryLoadingError: false,
                historyError: ''
            };
        case TYPES.FETCH_INVOICE_HISTORY.FULFILLED:
            return {
                ...state,
                history: action.history? action.history: defaultState.history,
                isFetchHistoryLoading: false,
                isFetchHistoryLoadingError: false,
            };
        case TYPES.FETCH_INVOICE_HISTORY.REJECTED:
            return {
                ...state,
                isFetchHistoryLoading: false,
                isFetchHistoryLoadingError: true,
                historyError: checkErr(action.errors)?checkErr(action.errors):'Fetching Invoice History has failed'
            }
        case TYPES.ADD_CREDIT_NOTES_INVOICES.PENDING:
            return {
                ...state,
                creditNoteError: false,
                creditNoteLoading: true,
                creditNoteResponse: ''
            };
        case TYPES.ADD_CREDIT_NOTES_INVOICES.FULFILLED:
            return {
                ...state,
                creditNoteError: false,
                creditNoteLoading: false,
                creditNoteResponse: action.creditNoteResponse?action.creditNoteResponse:'Credit Notes was Raised Successfully.'
            };
        case TYPES.ADD_CREDIT_NOTES_INVOICES.REJECTED:
            return {
                ...state,
                creditNoteError: true,
                creditNoteLoading: false,
                creditNoteResponse: action.creditNoteResponse?action.creditNoteResponse: 'Error on Adding Credit Note operation'
            };
        case TYPES.REPRINT_INVOICES.PENDING:
            return {
                ...state,
                reprintError: false,
                reprintLoading: true,
                reprintResponse: ''
            };
        case TYPES.REPRINT_INVOICES.FULFILLED:
            return {
                ...state,
                reprintError: false,
                reprintLoading: false,
                reprintResponse: action.creditNoteResponse? action.creditNoteResponse:'Reprint Successful.'
            };
        case TYPES.REPRINT_INVOICES.REJECTED:
            return {
                ...state,
                reprintError: true,
                reprintLoading: false,
                reprintResponse: action.creditNoteResponse? action.creditNoteResponse: 'Error while Reprinting'
            };
        case TYPES.FETCH_FILE.PENDING:
            return {
                ...state,
                downloadError: false,
                downloadResponse: ''
            };
        case TYPES.FETCH_FILE.FULFILLED:
            return {
                ...state,
                downloadError: false,
                downloadResponse: action.downloadResponse
            };
        case TYPES.FETCH_FILE.REJECTED:
            return {
                ...state,
                downloadError: true,
                downloadResponse: action.downloadResponse? action.downloadResponse: 'Error while Downloading'
            }; 
        case TYPES.FETCH_PDF_FILE.PENDING:
            return {
                ...state,
                downloadError: false,
                downloadPDFResponse: ''
            };
        case TYPES.FETCH_PDF_FILE.FULFILLED:
            return {
                ...state,
                downloadError: false,
                downloadPDFResponse: action.downloadPDFResponse
            };
        case TYPES.FETCH_PDF_FILE.REJECTED:
            return {
                ...state,
                downloadError: true,
                downloadPDFResponse: action.downloadPDFResponse? action.downloadPDFResponse: 'Error while Downloading PDF'
            };
        case TYPES.RESET_CUSTOMER_INVOICES.FULFILLED:
            return {
                ...state,
                searchCustomerInvoices: defaultState.searchCustomerInvoices,
                loadingCustomerInvoices: false,
                errorCustomerInvoices: false,
                pendingError: ''
            };
        case TYPES.FETCH_CUSTOMER_INVOICES_DATA.PENDING:
            return {
                ...state,
                searchCustomerInvoices: defaultState.searchCustomerInvoices,
                loadingCustomerInvoices: true,
                errorCustomerInvoices: false,
                pendingError: ''
            };
        case TYPES.FETCH_CUSTOMER_INVOICES_DATA.FULFILLED:
            return {
                ...state,
                searchCustomerInvoices: checkIfNull(action.searchCustomerInvoices),
                loadingCustomerInvoices: false,
                errorCustomerInvoices: false,
                pendingError: ''
            };
        case TYPES.FETCH_CUSTOMER_INVOICES_DATA.REJECTED:
            return {
                ...state,
                loadingCustomerInvoices: false,
                errorCustomerInvoices: true,
                pendingError: checkErr(action.errors)?checkErr(action.errors): msgs.Invoices.Pending_Error
            };
        
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_ORIGIN.PENDING:
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_DESTINATION.PENDING:
                return {
                    ...state,
                    isReprintOrDraftInvoiceAllowed: defaultState.isReprintOrDraftInvoiceAllowed,
                    isReprintOrDraftInvoiceAllowedError: false
                };
        
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_ORIGIN.FULFILLED:
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_DESTINATION.FULFILLED:
                return {
                    ...state,
                    isReprintOrDraftInvoiceAllowed: action.isReprintOrDraftInvoiceAllowed,
                    isReprintOrDraftInvoiceAllowedError: false
                };
        
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_ORIGIN.REJECTED:
            case TYPES.REPRINT_DRAFT_STATUS_VIEW_DESTINATION.REJECTED:
                return {
                    ...state,
                    isReprintOrDraftInvoiceAllowed: defaultState.isReprintOrDraftInvoiceAllowed,
                    isReprintOrDraftInvoiceAllowedError: checkErr(action.errors) 
                        ? checkErr(action.errors) 
                        : msgs.Invoices.Retrieve_Error
                };
        default:
            return state;
    }
};
